
import React from 'react';

/**
 * Props for the DataGridHeaderToolTip component.
 * @property {string} title - The text to display inside the tooltip.
 */
interface CustomTooltipProps {
    title: string;
}


const tooltipStyle: React.CSSProperties = {
    backgroundColor: 'var(--g-color-tooltip-background)',
    color: 'var(--g-color-tooltip-text)',
    padding: '0.5rem 0.5rem',
    borderRadius: '6px',
};

/**
 * A tooltip component for displaying header information in a data grid.
 *
 * @param {CustomTooltipProps} props - The props for the tooltip component.
 * @param {string} props.title - The text to display inside the tooltip.
 *
 * @returns {JSX.Element} The rendered tooltip component.
 */
const DataGridHeaderToolTip: React.FC<CustomTooltipProps> = ({ title }) => (
    <div style={tooltipStyle}>
        {title}
    </div>
);

export default DataGridHeaderToolTip;